import axios from '@/plugins/axios'
import { Module } from 'vuex'
import { sortCollection, sortCollectionWithArray } from '@/utils/collections'

const HashTagsModule: Module<any, any> = {
    actions: {
        async initHashTagsIndex() {
            if (this.tagIndexLoading) {
        		await this.initHashTagsPromise
        		return
        	}
            this.tagIndexLoading = true
            this.initHashTagsPromise = this.dispatch('initIndex', {
                id: 'hashTag',
                idField: 'slug',
                indexedFields: [
                    'slug', 'name', 
                ],
                source: '/api/hashtags',
                refresh: true,
            })
            await this.initHashTagsPromise
            this.tagIndexLoading = false
            this.initHashTagsPromise = null
        },

        async getHashTags(_, params) {
            const indexExists = await this.dispatch('indexExists', 'hashTag')

            if (!indexExists || params?.refresh) {
                await this.dispatch('initHashTagsIndex')
            }

            const sortName = (items) => {
                return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const sortMembers = (items) => {
                return sortCollectionWithArray(items, 'members', params?.sortOrder?.toLowerCase())
            }

            const sortContentCount = (items) => {
                return sortCollection(items, 'contentCount', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortPosts = (items) => {
                return sortCollection(items, 'stats.postsDelivered', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortEngagements = (items) => {
                return items?.sort((a, b) =>
                a?.stats.likes + a?.stats.comments + a?.stats.reshares < b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? -1 : 1
                    : a?.stats.likes + a?.stats.comments + a?.stats.reshares > b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? 1 : -1
                    : 0,
                )
            }
            
            const sortClicks = (items) => {                
                return sortCollection(items, 'stats.clicks', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const sortMediaPoints = (items) => {
                return sortCollection(items, 'mediaPoints', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const getSortOrder = () => {
                if (params?.sortBy === 'contentCount') {
                    return sortContentCount
                } else if (params?.sortBy === 'members') {
                    return sortMembers
                } else if (params?.sortBy === 'posts') {
                    return sortPosts
                } else if (params?.sortBy === 'engagements') {
                    return sortEngagements
                } else if (params?.sortBy === 'clicks') {
                    return sortClicks
                } else if (params?.sortBy === 'media_points') {
                    return sortMediaPoints
                } else {
                    return sortName
                }
            }
            
            let records = null
            records = await this.dispatch('getRecords', {
                index: 'hashTag',
                term: params?.search,
                fields: ['name'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                sort: getSortOrder(),
            })

            return records

        },

        async createHashTag(_, params) {
            const response = await axios.post('/api/hashtags', {
                name: params.name
            })
            return response
        },

        async editHashTag(_, params) {
            const response = await axios.put(`/api/hashtags/${params.slug}`, {
                name: params.name
            })
            return response
        },
        
        async deleteHashTag(_, params) {
            let data
            await axios.delete(`/api/hashtags/${params.slug}`).then((response) => {
                data = response.data
            })
            return data
        },
    }
}


export default HashTagsModule